export default __webpack_public_path__ + "static/media/030-three.e1f655a6.svg";